import { useEnteringImpersonationManage } from "./useEnteringImpersonationManage"
import { useExitingImpersonationManage } from "./useExitingImpersonationManage"

export const useAuthImpersonationManage = (args: { isAuthed: boolean }) => {
  useExitingImpersonationManage(args)
  useEnteringImpersonationManage(args)
}
